import apiClient from "../ApiClient";

const userService = () => {
  const { request } = apiClient();

  const signin = async (credentials) => {
    try {
      return await request("POST", "/user/login", credentials);
    } catch (error) {
      console.error("Failed to sign-in user:", error.message);
      throw error;
    }
  };

  const validateUser = async (username) => {
    try {
      return await request("POST", "/user/validate-user", username);
    } catch (error) {
      console.error("Failed to validate user:", error.message);
      throw error;
    }
  };

  const resetPassword = async (id, newPassword, confirmPassword) => {
    try {
      const credentials = {
        id: id,
        newPassword: newPassword,
        confirmPassword: confirmPassword
      };
      return await request("POST", "/user/reset-password", credentials);
    } catch (error) {
      console.error("Failed to reset password:", error.message);
      throw error;
    }
  };

  const userList = async () => {
    try {
      return await request("GET", "/user/user-list");
    } catch (error) {
      console.error("Failed to get user list:", error.message);
      throw error;
    }
  };

  const userGroupList = async () => {
    try {
      return await request("GET", "/user/user-groups");
    } catch (error) {
      console.error("Failed to get user group list:", error.message);
      throw error;
    }
  };

  return {
    signin,
    validateUser,
    resetPassword,
    userList,
    userGroupList
  };
};

export default userService;